import { render, staticRenderFns } from "./Wrinkles.vue?vue&type=template&id=2d38d83f"
import script from "./Wrinkles.vue?vue&type=script&lang=js"
export * from "./Wrinkles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports